import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import pallet from '../../layouts/pallet';
import { StyledButton } from '../../modules/Exams/styled';

export const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  gap: theme.spacing(2),
  flexWrap: 'wrap',
  justifyContent: 'space-between'
}));

export const HiddenInput = styled('input')({
  display: 'none'
});

export const DropZone = styled(Box)(() => ({
  border: `2px dashed ${pallet.divider}`,
  borderRadius: 8,
  padding: '16px 24px',
  minWidth: 450,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 12,
  cursor: 'pointer',
  backgroundColor: pallet.lightGrey,
  transition: 'border-color 0.2s ease, background-color 0.2s ease',
  '&:hover': {
    borderColor: pallet.divider,
    backgroundColor: pallet.secondaryHover
  }
}));

export const CenterIconBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

export const FileMetaCol = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 300
}));

export const FileNameRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '100%'
}));

export const RemoveFileIcon = styled('span')(() => ({
  marginLeft: 8,
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  color: pallet.textGrey,
  '&:hover': { color: pallet.error }
}));

export const ActionsWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8
}));

export const UploadButton = styled(StyledButton)(() => ({
  whiteSpace: 'nowrap',
  height: 44,
  minWidth: 120,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

export const PaperWrapper = styled(Box)(({ theme }) => ({
  marginTop: 16,
  maxWidth: '95%',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 32,
  paddingBottom: 32,
  backgroundColor: '#fff',
  borderRadius: 8,
  boxShadow:
    '0px 2px 4px -1px #e0e0e0, 0px 4px 5px 0px #bdbdbd, 0px 1px 10px 0px #9e9e9e',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  minHeight: '125px',
  boxSizing: 'border-box'
}));
